import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { LoanApplicationDto } from 'src/generated-api-client';

type AgentLoanApplicationGeneralInfoProps = {
    application?: LoanApplicationDto;
};

export const AgentLoanApplicationGeneralInfo = observer(
    ({ application }: AgentLoanApplicationGeneralInfoProps) => {
        return (
            <Card title={t('Agent.LoanApplication.GeneralInfo.Title')}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.GeneralInfo.ApplicationID',
                            )}
                            value={application?.number}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.GeneralInfo.CreatedAt',
                            )}
                            value={application?.createdAt}
                            formatValue="dateTimeSeconds"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.GeneralInfo.PhoneNumber',
                            )}
                            value={application?.phoneNumber}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.GeneralInfo.Merchant',
                            )}
                            value={application?.merchant?.number}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.GeneralInfo.JahezMerchantId',
                            )}
                            value={
                                (application?.merchant as any)
                                    ?.externalMerchantId
                            }
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
